import { QUERY } from "../api/home"
function defotquery() {
    QUERY().then(res => {
        if(res.data.code == 'forceout'){
            alert('123')
        }
    })
}
export default{
    defotquery
} 